import React, { createContext, useContext, useState, ReactNode } from 'react';
import { MenuProduct } from '../services/MenuService.ts';

interface ProductsContextType {
  products: MenuProduct[];
  setProducts: (products: MenuProduct[]) => void;
}

const ProductsContext = createContext<ProductsContextType | undefined>(undefined);

export function ProductsProvider({ children }: { children: ReactNode }) {
  const [products, setProducts] = useState<MenuProduct[]>([]);

  return (
    <ProductsContext.Provider value={{ products, setProducts }}>
      {children}
    </ProductsContext.Provider>
  );
}

export function useProducts() {
  const context = useContext(ProductsContext);
  if (context === undefined) {
    throw new Error('useProducts must be used within a ProductsProvider');
  }
  return context;
}
